import React from 'react';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';
import { WysiwygField } from '../../../../components';

import './style.scss';

const NodeLocationTeaser = ({ entity }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['title', 0, 'value']);
  const emailAddresses = entity.getIn(['field_email', 0, 'value']);
  const address = entity.getIn(['field_address', 0]);
  const telephoneNumbers = entity.getIn(['field_telephone'], List());

  const remarks = entity.getIn(['field_remarks', 0, 'value']);
  const openingHours = entity.getIn(['field_opening_hours', 0, 'value']);
  const visitingHours = entity.getIn(['field_visiting_hours', 0, 'value']);

  return (
    <div className="BaseTeaser NodeLocationTeaser col-12">
      <div className="NodeLocationTeaser">
        <div className="NodeLocationTeaser__title">
          <h3>{title}</h3>
        </div>
        <div className="NodeLocationTeaser__details">
          {address && (
            <div>
              <div>{address.get('address_line1')}</div>
              {address.get('postal_code')}, {address.get('locality')}
            </div>
          )}
          {telephoneNumbers && (
            <div className="phone">
              {telephoneNumbers.map((telephoneNumber) => {
                return (
                  <a href={`mailto:${telephoneNumber.get('value')}`} className="mr-1">
                    {telephoneNumber.get('value')}
                  </a>
                );
              })}
            </div>
          )}
          {emailAddresses && (
            <div>
              {emailAddresses && emailAddresses.split(',').map((email) => {
                return (
                  <>
                    <a href={`mailto:${email}`}>
                      {email}
                    </a>
                    <br />
                  </>
                );
              })}
            </div>
          )}
        </div>

        <br />

        {openingHours && (
          <div className="NodeLocationTeaser__content mb-2">
            <b>{t('general.opening_hours')}:</b>
            <WysiwygField
              property="schema:text"
              className="ParagraphText__body"
              html={openingHours}
            />
          </div>
        )}

        {visitingHours && (
          <div className="NodeLocationTeaser__content mb-2">
            <b>{t('general.visiting_hours')}:</b>
            <WysiwygField
              property="schema:text"
              className="ParagraphText__body"
              html={visitingHours}
            />
          </div>
        )}

        {remarks && (
          <div className="NodeLocationTeaser__content mb-2 mt-2">
            <b>{t('general.remarks')}:</b>
            <WysiwygField
              property="schema:text"
              className="ParagraphText__body"
              html={remarks}
            />
          </div>
        )}

      </div>
    </div>
  );
};

export default NodeLocationTeaser;
